import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { FileFilterList } from 'app/models/file-filter-list';
import { AssetSortingType } from 'app/models/asset-sorting-type';
import { FileFilterOption } from 'app/models/file-filter-option';
import { UPTOPResult } from 'app/models/uptop';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private apiUrl = environment.api.url + environment.api.content.url;

  constructor(private http: HttpClient) { }

  search(
    filters: FileFilterList,
    searchText: string,
    searchCompetition: string,
    lastEvaluatedKey: any,
    sortingType: AssetSortingType
  ): Observable<UPTOPResult> {
    const sources = this.getFilters(filters);
    let params = new HttpParams();
    params = params.append('op', environment.api.content.type.search.op);
    params = params.append('search_type', environment.api.content.type.search.type);
    params = params.append('source', sources.join(','));
    params = searchText ? params.append('search_term', searchText) : params;
    params = sortingType ? params.append('filter', sortingType.id) : params;
    params = searchCompetition ? params.append('competition', searchCompetition) : params;
    
    let headers = new HttpHeaders();
    if (lastEvaluatedKey) {
      headers = headers.append('lastevaluatedkey', btoa(JSON.stringify(lastEvaluatedKey)));
    }

    return this.http
      .get<UPTOPResult>(this.apiUrl, { headers, params })
      .pipe(
        map((res) => res as UPTOPResult),
        catchError(err => throwError(err || 'ServerErr'))
      );
  }

  private getFilters(filters: FileFilterList): Array<string> {
    return Object.keys(filters)
      .map((key) => filters[key].value ? (filters[key] as FileFilterOption).source : null)
      .filter((data) => data);
  }
}
